var map = {
	"./accessibility.svg": 425,
	"./angle-down.svg": 957,
	"./backspace.svg": 600,
	"./cart.svg": 849,
	"./clock.svg": 75,
	"./close.svg": 837,
	"./contrast.svg": 50,
	"./font-size.svg": 782,
	"./info.svg": 947,
	"./minus.svg": 441,
	"./plus.svg": 491,
	"./search.svg": 343,
	"./tick.svg": 920,
	"./trash.svg": 891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;